/* @ngInject */
function HomeTemplatesItemController ($scope, $rootScope, $state, $q, $translate, CONSTANTS, Utils, MessageService, ModalService, ProductsService, ConnectorWebService, TemplateService, UdsModalService) {
  const getDownloadDialogController = () => $q.when(import('../../../arts/dialogs/download/download-dialog.controller'))
  const getTemplateSuggestionsDialogController = () => $q.when(import('../../../arts/dialogs/template-suggestions/template-suggestions-dialog.controller'))

  $scope.defaultThumb = false

  const api = {
    getDownloadDialogController,
    getTemplateSuggestionsDialogController,
    _openDownloadDialog,
    _showTemplateSuggestions,
    _handleCustomizeTemplateClick,
    _handleDownloadTemplate
  }
  this.getApi = () => api

  activate()

  function activate () {
    jQuery('.home-options-btn-dropdown').dropdown({
      showOnFocus: false,
      on: 'click'
    })
  }

  $scope.getThumbnailSrc = function (art) {
    if (art.isCustomizable || art.thumbnailContentType || art.hasCover) {
      $scope.defaultThumb = false

      let url = CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL

      if (!art.isTemplate) {
        url = CONSTANTS.URL_ARTS_THUMBNAIL_ID
      }

      return Utils.fnReplaceStringParams(url, [art.id])
    } else {
      $scope.defaultThumb = true

      return TemplateService.getDefaultThumbnail(art.extension)
    }
  }

  $scope.handleTemplateClick = function (template) {
    if ((template.customizationLevel === 'ONLY_DOWNLOAD' && !$rootScope.isUserSysAdminAdmin()) || !template.isCustomizable) {
      api._handleDownloadTemplate(template)
    } else if (template.isCustomizable && (template.customizationLevel !== 'ONLY_DOWNLOAD' || $rootScope.isUserSysAdminAdmin())) {
      api._handleCustomizeTemplateClick(template)
    }
  }

  function _handleCustomizeTemplateClick (template) {
    if (!$rootScope.isDesktop) {
      showMobileDialog()
      return
    }

    $state.go('customizeTemplate', {
      templateId: template.id,
      from: $state.current.name,
      fromParams: $state.params
    })
  }

  function _handleDownloadTemplate (template) {
    if (!template.isCustomizable) {
      downloadAssetTemplate(template)
    } else if (template.customizationLevel === 'ONLY_DOWNLOAD') {
      api._openDownloadDialog(template)
    }
  }

  function _openDownloadDialog (template) {
    api.getDownloadDialogController().then(({ DownloadDialogController }) => {
      const downloadDialog = UdsModalService.createModal({
        controller: DownloadDialogController,
        modalName: 'downloadDialog',
        data: {
          _iArtId: template.id,
          _sDownloadOption: template.downloadOption,
          _customizationLevel: template.customizationLevel,
          _isCustomizable: template.isCustomizable,
          _oTemplate: template
        }
      })

      downloadDialog.open()
    })
  }

  function downloadAssetTemplate (template) {
    return ProductsService.getProductById(template.productId).then(product => {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [template.id])
      api._showTemplateSuggestions(product, template)
      return Utils.downloadFile(url, template.id)
    })
  }

  function _showTemplateSuggestions (product, template) {
    if (template.detailsId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID, [template.id])
      ConnectorWebService.get(url).then(function (templ) {
        if (templ && templ.details && templ.details.suggestions) {
          api.getTemplateSuggestionsDialogController().then(({ TemplateSuggestionsDialogController }) => {
            ModalService.showModal({
              templateId: 'templateSuggestions.html',
              templateUrl: '/arts/dialogs/template-suggestions/template-suggestions-dialog.html?$$REVISION$$',
              controller: TemplateSuggestionsDialogController,
              destroyable: true,
              data: {
                _sSuggestions: templ.details.suggestions,
                _bIsPrintInstruction: product && product.type === 'PRINTABLE'
              }
            })
          })
        }
      })
    }
  }

  function showMobileDialog () {
    MessageService.error({
      title: $translate.instant('oopsTitle'),
      text: $translate.instant('mobileCustomizeNotAllowed') + '\n\n' + $translate.instant('continueWorkOnPC'),
      confirmButtonText: $translate.instant('ok')
    })
  }
}

export { HomeTemplatesItemController }
